import React, { useEffect, useRef, useState } from "react";
import { Chip, DialogContentText, InputAdornment } from "@mui/material";
import {
  Snackbar,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  Button,
  Modal,
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Pagination,
  Card,
  CardMedia,
  Paper,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  Delete,
  CheckCircle,
  PlayCircleFilledWhite,
  ContentPasteSearchOutlined,
} from "@mui/icons-material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PlayCircleFilled, PauseCircleFilled } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import "./Transitions.css";
import CustomisationSelector from "./CustomisationSelector";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { setPlaylist } from "../../redux/slices/playlistSlice";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import MediaPreviewInPlaylist from "./MediaPreviewInPlaylist";
import Badge, { badgeClasses } from "@mui/material/Badge";
import {
  mostFrequent,
  isVideoFormat,
  getVideoDuration,
  handleAddItemsToPlaylist,
  handleDurationChange,
  handleRemoveItem,
  handleMoveUp,
  handleMoveDown,
  handleSetDurationForAll,
  startSlideshow,
  stopSlideshow,
  toggleSlideshow,
  goToPreviousPreview,
  goToNextPreview,
  isCustomizationSelected,
  transformPlaylistItems,
  showMismatchError,
  dismissMismatchError,
  checkOrientationMismatch,
  getMismatchedIds,
} from "./utils/playlistUtils";


const MyPlaylistForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [playlistName, setPlaylistName] = useState("");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const [isSlideshowActive, setIsSlideshowActive] = useState(false);
  const [slideshowIntervalId, setSlideshowIntervalId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [transitionEffect, setTransitionEffect] = useState("fade");
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const selectedOption = curremms.curremms.id;
  const user = useSelector((state) => state?.user?.user);
  const eventcustomisations = useSelector(
    (state) => state?.eventcustomisations?.eventcustomisations
  );
  const templates = useSelector((state) => state?.template?.template);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );

  const itemsPerPage = 6;
  const playlist = useSelector((state) => state?.playlist?.playlist);
  const [playlistOrientation, setPlaylistOrientation] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [open, setOpen] = useState("");
  const [duration, setDuration] = useState("");
  const mismatchToastId = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const hasMismatch = checkOrientationMismatch(items, playlistOrientation);

    if (hasMismatch) {
      showMismatchError(mismatchToastId);
    } else {
      dismissMismatchError(mismatchToastId);
    }
  }, [items, playlistOrientation]);

  const mismatchedIds = getMismatchedIds(items, playlistOrientation);

  const handleAddItems = (selectedItems) => {
    handleAddItemsToPlaylist(
      selectedItems,
      dataToDisplay,
      items,
      setItems,
      setPlaylistOrientation
    );
  };

  const handleSetDuration = () => {
    handleSetDurationForAll(duration, items, setItems, setOpen);
  };

  const handleToggleSlideshow = () => {
    toggleSlideshow(
      isPlaying,
      () =>
        startSlideshow(
          items,
          setCurrentPreviewIndex,
          setLoading,
          setIsSlideshowActive,
          setSlideshowIntervalId
        ),
      () =>
        stopSlideshow(
          isSlideshowActive,
          slideshowIntervalId,
          setSlideshowIntervalId,
          setIsSlideshowActive
        ),
      setIsPlaying
    );
  };

  const handleGoToPreviousPreview = () => {
    goToPreviousPreview(currentPreviewIndex, setCurrentPreviewIndex, items);
  };

  const handleGoToNextPreview = () => {
    goToNextPreview(currentPreviewIndex, setCurrentPreviewIndex, items);
  };

  const handleRemoveItemFromPlaylist = (index) => {
    handleRemoveItem(
      index,
      items,
      setItems,
      currentPreviewIndex,
      setCurrentPreviewIndex
    );
  };

  const handleMoveItemUp = (index) => {
    handleMoveUp(index, items, setItems);
  };

  const handleMoveItemDown = (index) => {
    handleMoveDown(index, items, setItems);
  };

  const handleDurationChangeForItem = (index, value) => {
    handleDurationChange(index, value, items, setItems);
  };

  const isCustomizationSelectedInPlaylist = (customizationId) => {
    return isCustomizationSelected(customizationId, items);
  };

  const handleTransitionChange = (event) => {
    setTransitionEffect(event.target.value);
  };

  const modalClose = () => {
    setIsModalOpen(false);
    setItems([]);
    setCurrentPreviewIndex(0);
    setIsPlaying(false);
    setIsSlideshowActive(false);
    setPlaylistName("");
    setOpen("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!playlistName?.trim()) {
      setIsNameDialogOpen(true);
      return;
    }
    if (!items || items.length === 0) {
      toast.error("Playlist must have at least one item.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const playlistData = {
      name: playlistName,
      items: items.map((item) => {
        const matchingEntry = dataToDisplay.find(
          (data) => data.id === item.customizationId
        );

        if (matchingEntry) {
          return {
            ...matchingEntry,
            duration: item.duration,
          };
        }
      }),
      customProperties: {
        contentAiPlaylistMaker: user?.email,
        metaData: {
          orientation: playlistOrientation,
        },
      },
    };
    const transformedItems = transformPlaylistItems(playlistData);
    playlistData.items = transformedItems;

    const requestBody = {
      path: "playlist",
      query: {},
      body: { ...playlistData },
      emmsId: `${selectedOption}`,
      requestType: "POST",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setIsSubmitting(false);

        const combinedData = [response.data, ...playlist];

        dispatch(setPlaylist(combinedData));

        setErrorModalOpen(true);

        setErrorMessage(`Playlist created successfully`);

        setSuccessMessage(true);
      })
      .catch((error) => {
        setErrorModalOpen(true);

        setErrorMessage(`Error creating template: ${error?.response?.data}`);
        setSuccessMessage(false);
      });
    modalClose();
  };

  const [isNameDialogOpen, setIsNameDialogOpen] = useState(false);
  const [tempPlaylistName, setTempPlaylistName] = useState("");
  const handleNameConfirm = () => {
    setPlaylistName(tempPlaylistName);
    setIsNameDialogOpen(false);
  };

  useEffect(() => {
    if (playlistName) {
      handleSubmit(new Event("submit"));
    }
  }, [playlistName]);

  const [globalTransitionEffect, setGlobalTransitionEffect] = useState("fade");
  const [individualTransitions, setIndividualTransitions] = useState([]);

 
  const handleGlobalTransitionChange = (event) => {
    setGlobalTransitionEffect(event.target.value);
  };


  const handleItemTransitionChange = (index, transitionEffect) => {
    const updatedTransitions = [...individualTransitions];
    updatedTransitions[index] = transitionEffect;
    setIndividualTransitions(updatedTransitions);
  };
  const getTransitionClass = (index) => {
    const transitionEffect =
      individualTransitions[index] || globalTransitionEffect;
    return `transition-${transitionEffect}`;
  };

  useEffect(() => {
    // Cleanup slideshow interval on component unmount
    return () => clearInterval(slideshowIntervalId);
  }, [slideshowIntervalId]);

  return (
    <>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setIsModalOpen(true)
          }}
          style={{ textTransform: "none" }}
        >
          Create Playlist
        </Button>

        <Modal open={isModalOpen} onClose={modalClose}>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100%",
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: 2,
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f4f4f9", 
              }}
            >
              <Typography
                color="primary"
                variant="h6"
                sx={(theme) => ({
                  fontSize: {
                    xs: "1rem",
                    sm: "1.1rem",
                    md: theme.typography.h6.fontSize,
                  },
                })}

              >
                Elhi Landscape Manager
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  sx={{
                    minWidth: {
                      xs: 80,
                      md: 120
                    }
                  }}
                >
                  <Select
                    size="small"
                    value={transitionEffect}
                    onChange={handleTransitionChange}
                    displayEmpty
                    sx={{
                      fontSize: "0.875rem",
                      maxHeight: "5vh",
                    }}
                  >
                    <MenuItem value="" disabled>
                      Choose Transition
                    </MenuItem>
                    <MenuItem value="fade">Fade</MenuItem>
                  </Select>
                </FormControl>

                <>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Tooltip title="Set Duration for All Items">
                      <IconButton
                        onClick={() => setOpen(true)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 0.5,
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Set Duration
                        </Typography>
                        <AccessTimeIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Dialog
                    open={isNameDialogOpen}
                    onClose={() => setIsNameDialogOpen(false)}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                      style: { borderRadius: 12, padding: "8px 16px" },
                    }}
                  >
                    <DialogTitle>
                      <Typography variant="h6" fontWeight="bold">
                        Enter Playlist Name
                      </Typography>
                    </DialogTitle>

                    <DialogContent>
                      <DialogContentText sx={{ mb: 2 }}>
                        Please provide a name for your playlist.
                      </DialogContentText>

                      <TextField
                        autoFocus
                        margin="dense"
                        label="Playlist Name"
                        fullWidth
                        variant="outlined"
                        value={tempPlaylistName}
                        onChange={(e) => setTempPlaylistName(e.target.value)}
                        InputProps={{
                          sx: { borderRadius: 2 },
                        }}
                      />
                    </DialogContent>

                    <DialogActions
                      sx={{ justifyContent: "space-between", padding: "16px" }}
                    >
                      <Button
                        onClick={() => setIsNameDialogOpen(false)}
                        color="error"
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={handleNameConfirm}
                        disabled={!tempPlaylistName.trim()}
                        color="primary"
                        variant="contained"
                      >
                        Confirm
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog open={open} onClose={() => setOpen(false)}>
                    <DialogTitle>Set Duration</DialogTitle>
                    <DialogContent>
                      <TextField
                        autoFocus
                        label="Duration (seconds)"
                        type="number"
                        fullWidth
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpen(false)}>Cancel</Button>
                      <Button onClick={handleSetDuration} color="primary">
                        Set
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              </Box>
            </Box>

            <Box
              sx={{ display: "flex", flex: 1, overflow: "hidden", padding: 2, flexDirection: { xs: "column", md: "row" } }}
            >
              <Box
                sx={{
                  flex: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",

                  position: "relative",
                  overflow: "hidden",
                  width: { xs: "100%", md: "50vw" },
                  height: 300,
                }}
              >
                {items?.length > 0 ? (
                  <>
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: 5,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                      onClick={handleGoToPreviousPreview}
                    >
                      <ArrowBack />
                    </IconButton>
                    <Box
                      sx={{
                        width: { xs: "80%", md: "40%" },
                        height: "90%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        border: "4px solid #4caf50",
                      }}
                    >
                      <MediaPreviewInPlaylist
                        matchedRecord={dataToDisplay.find(
                          (data) =>
                            data.id ===
                            items[currentPreviewIndex]?.customizationId
                        )}
                      />
                    </Box>

                    <Typography
                      sx={{
                        position: "absolute",
                        bottom: 10,
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        padding: "5px",
                        borderRadius: "4px",
                      }}
                    >
                      {currentPreviewIndex + 1} / {items.length}
                    </Typography>
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 5,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                      onClick={handleGoToNextPreview}
                    >
                      <ArrowForward />
                    </IconButton>
                  </>
                ) : (
                  <Typography variant="subtitle1" color="textSecondary">
                    Select content to create Playlist
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  flex: { xs: 5, md: 1 },
                  padding: 2,
                  overflow: "auto",
                  borderLeft: "1px solid #ddd",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                  <Chip
                    label="Playlist Items"
                    sx={{
                      fontSize: ".8rem",
                      padding: "4px 12px",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
                {items?.map((item, index) => {
                  const isMismatch = item.orientation !== playlistOrientation;

                  return (
                    <React.Fragment key={index}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2,
                          height: "65px",
                          width: 280,
                          p: 2,
                          borderRadius: 1,
                        }}
                      >
                        <Badge
                          color="error"
                          variant="dot"
                          overlap="rectangular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          sx={{
                            [`& .${badgeClasses.dot}`]: {
                              width: 13,
                              height: 13,
                              borderRadius: "50%",
                            },
                          }}
                          invisible={!isMismatch}
                        >
                          <CardMedia
                            component="img"
                            image={
                              item.customizationId === "content-ai"
                                ? "https://storage.googleapis.com/content_ai_bucket_elhitech/content/contentAI%20placeholder.png"
                                : eventcustomisations.find(
                                  (c) => c.id === item.customizationId
                                )?.customisations[0]?.imageUrl ||
                                "https://storage.googleapis.com/content_ai_bucket_elhitech/content/template%20placeholder.png"
                            }
                            alt="Video"
                            sx={{
                              width: 60,
                              height: 50,
                              borderRadius: 1,
                              mr: 2,
                            }}
                          />
                        </Badge>
                        <TextField
                          label="Duration (sec)"
                          type="number"
                          variant="outlined"
                          size="small"
                          value={item.duration}
                          onChange={(e) =>
                            handleDurationChangeForItem(index, e.target.value)
                          }
                          required
                          sx={{
                            flex: 2,
                            mr: 1,
                            width: 100,

                            "& .MuiInputBase-root": {
                              fontSize: "0.875rem",
                              height: 36,
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "0.75rem",
                            },
                          }}
                        />

                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleMoveItemUp(index)}
                          disabled={index === 0}
                        >
                          <KeyboardArrowUpIcon />
                        </IconButton>

                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleMoveItemDown(index)}
                          disabled={index === items.length - 1}
                        >
                          <KeyboardArrowDownIcon />
                        </IconButton>

                        <IconButton
                          color="error"
                          onClick={() => handleRemoveItemFromPlaylist(index)}
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                      {index < items.length - 1 && <Divider />}
                    </React.Fragment>
                  );
                })}

                <CustomisationSelector
                  handleAddItems={handleAddItems}
                  isCustomizationSelected={isCustomizationSelectedInPlaylist}
                />
              </Box>
            </Box>

            <Box
              sx={{
                borderTop: "1px solid #ddd",
                padding: 2,
                backgroundColor: "#f7f7f7",
              }}
            >
              <div
                className="footer-section"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <IconButton
                    onClick={handleToggleSlideshow}
                    sx={{
                      ml: 2,
                      mr: 2,
                      backgroundColor: isPlaying ? "#19433E" : "#19433E", 
                      padding: "12px",
                    }}
                  >
                    {isPlaying ? (
                      <PauseCircleFilled sx={{ fontSize: 20, color: "white" }} />
                    ) : (
                      <PlayCircleFilled sx={{ fontSize: 20, color: "white" }} />
                    )}
                  </IconButton>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={modalClose}
                    color="error"
                    style={{ textTransform: "none" }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={items?.length === 0}
                    style={{ textTransform: "none" }}
                  >
                    Create Playlist
                  </Button>
                </div>
              </div>
            </Box>
          </Box>
        </Modal>
      </div>

    </>
  );
};

export default MyPlaylistForm;
